import { Component, OnInit } from '@angular/core';
import { locale, loadMessages } from 'devextreme/localization';
import esMessages from 'devextreme/localization/messages/es.json';
import { GoogleAnalyticsService } from './_services/google-analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {

  constructor(private googleAnalytics: GoogleAnalyticsService) {}

  ngOnInit() {
    loadMessages(esMessages);
    locale('es');
    this.googleAnalytics.inicializar();
  }
}
